import React from 'react'
import ReactDOM from 'react-dom'
import { FocusStyleManager } from '@blueprintjs/core'

import App from './app'

FocusStyleManager.onlyShowFocusOnTabs()

ReactDOM.render(<App/>, document.getElementById('app'))
